export const COLORS = ["#7d9198", "#374246", "#ffcc4f", "#d99e38", "#b2d4bd"];
